import "./autocomplete.css"

// Location Autocomplete Component (Shadow DOM + AbortController)
export default (url = window.NEXT_URL + '/location/search') => ({

    url,

    init() {
        this.root = this.$el.getRootNode();
        this.win = this.root.host?.ownerDocument?.defaultView || window;

        // abort controller for all the component
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.setupAutocomplete(this.$refs.plz, signal);
        this.setupAutocomplete(this.$refs.ort, signal);

        this._onHtmxConfig = this.handleHtmxConfigRequest.bind(this);
        this.root.addEventListener('htmx:configRequest', this._onHtmxConfig, { signal });
    },

    handleHtmxConfigRequest(event) {
        const formData = event.detail.formData;
        if (!(formData instanceof FormData)) return;

        // Ne renommer que pour les requ�tes d'autocomplete (hx-get sur les inputs)
        const triggerElt = event.detail.elt;
        if (triggerElt !== this.$refs.plz && triggerElt !== this.$refs.ort) return;

        this.renameField(formData, this.$refs.plz, 'plz');
        this.renameField(formData, this.$refs.ort, 'ort');
    },

    renameField(formData, el, newName) {
        const originalName = el.getAttribute('name');
        if (formData.has(originalName)) {
            const value = formData.get(originalName);
            formData.delete(originalName);
            formData.set(newName, value);
        }
    },

    setupAutocomplete(input, signal) {

        const results = document.createElement('div');
        results.className = 'autocomplete-results';
        results.id = this.uniqueId();
        this.root.appendChild(results);

        input.setAttribute('hx-get', this.url);
        input.setAttribute('hx-trigger', 'keyup changed delay:300ms');
        input.setAttribute('hx-target', `#${results.id}`);
        input.setAttribute('hx-swap', 'innerHTML');

        htmx.process(input);

        const positionResults = () => {
            const rect = input.getBoundingClientRect();
            results.style.position = 'fixed';
            results.style.top = `${rect.bottom}px`;
            results.style.left = `${rect.left}px`;
            results.style.width = `${rect.width}px`;
        };

        this.win.addEventListener('resize', positionResults, { signal });
        this.win.addEventListener('scroll', positionResults, { signal, capture: true });

        const afterSwapHandler = (e) => {
            if (e.target === results) {
                positionResults();
                results.classList.toggle('show', results.children.length > 0);

                results.querySelectorAll('.autocomplete-item').forEach(item => {
                    item.addEventListener('click', () => {
                        this.selectItem(item);
                        results.innerHTML = '';
                        results.classList.remove('show');
                    });
                });
            }
        };

        this.root.addEventListener('htmx:afterSwap', afterSwapHandler, { signal });

        const clickOutsideHandler = (e) => {
            const path = e.composedPath?.() || [];
            if (!path.includes(results) && !path.includes(input)) {
                results.innerHTML = '';
                results.classList.remove('show');
            }
        };

        this.root.addEventListener('click', clickOutsideHandler, { signal });
    },

    selectItem(item) {
        this.$refs.plz.value = item.dataset.plz;
        this.$refs.ort.value = item.dataset.ort;
    },

    uniqueId() {
        return 'autocomplete-results-' + Math.random().toString(36).slice(2, 9);
    },

    destroy() {
        // une seule ligne pour tout nettoyer
        this.abort.abort();
    }

});